import { useState } from 'react';
import Navigation from '../../home/components/Navigation';
import Footer from '../../home/components/Footer';
import CharterInquiryForm from '../../superyacht-detail/components/CharterInquiryForm';

const OPariPage = () => {
  const [selectedImage, setSelectedImage] = useState(0);

  const images = [
    'https://www.northropandjohnson.com/api/v1/files/4f0e0e5c-e0c0-4e8f-b0c0-e0c0e0c0e0c0',
    'https://www.northropandjohnson.com/api/v1/files/5f0e0e5c-e0c0-4e8f-b0c0-e0c0e0c0e0c1',
    'https://www.northropandjohnson.com/api/v1/files/6f0e0e5c-e0c0-4e8f-b0c0-e0c0e0c0e0c2',
    'https://www.northropandjohnson.com/api/v1/files/7f0e0e5c-e0c0-4e8f-b0c0-e0c0e0c0e0c3',
    'https://www.northropandjohnson.com/api/v1/files/8f0e0e5c-e0c0-4e8f-b0c0-e0c0e0c0e0c4',
    'https://www.northropandjohnson.com/api/v1/files/9f0e0e5c-e0c0-4e8f-b0c0-e0c0e0c0e0c5',
    'https://www.northropandjohnson.com/api/v1/files/af0e0e5c-e0c0-4e8f-b0c0-e0c0e0c0e0c6'
  ];

  const specifications = [
    { label: 'Builder', value: 'Golden Yachts' },
    { label: 'Year', value: '2020/2021' },
    { label: 'Length', value: '311\' 8" (95m)' },
    { label: 'Beam', value: '49\' 2" (15m)' },
    { label: 'Draft', value: '11\' 2" (3.4m)' },
    { label: 'Guests', value: '12' },
    { label: 'Cabins', value: '7' },
    { label: 'Crew', value: '31' },
    { label: 'Speed (Max)', value: '17 knots' },
    { label: 'Speed (Cruise)', value: '15 knots' }
  ];

  const amenities = [
    { icon: 'ri-ship-line', label: 'Beach Club' },
    { icon: 'ri-water-flash-line', label: 'Jacuzzi' },
    { icon: 'ri-plane-line', label: 'Helipad' },
    { icon: 'ri-wifi-line', label: 'Wi-Fi' },
    { icon: 'ri-restaurant-line', label: 'Elevator' },
    { icon: 'ri-swimming-pool-line', label: 'Swimming Pool' },
    { icon: 'ri-dumbbell-line', label: 'Gym' },
    { icon: 'ri-spa-line', label: 'Massage' }
  ];

  const toysAndTenders = [
    '1 x Limo Tender Intrepid 37\'5m, with twin x 350hp Verado Petrol (13 engines)',
    '1 x Boesch/Axe Limo 29\'',
    '1 x PWCs Craft Launch 27\' with an Inboard Mercury V8 6.2L, 350hp engine',
    '1 x Castoldi Jet Tender 19\' with an outboard Yamaha 60hp engine',
    '1 x Zodiac Typhoon 380 Alu',
    '1 x Schrader rescue tender 18\'6m with an outboard YAMAHA 90hp',
    'Jetskis',
    '2 x Seabobs GTI 320 (SR)',
    '1 x Seabobs Shark 900W AXE SURF/SUP Toys',
    '1 x Sublue US Bixpy Jetpack',
    '1 x Sublue ETI (Bixpy yellow, Basic orange, Non-Fluo Petrol-blue)',
    '2 x FTelescopes',
    '1 x Bongo Kayak Polar Starfin with Bixpy Jet',
    '1 x Manta 2+1 seats sea Kayak w/paddles & seats',
    '1 x Spinera Inflatable Single Kayak',
    '1 x Spinera Inflatable 2-Seat Kayak',
    '2 x Aqua Range Eclipse Paddleboard (1ha inflatables)',
    '1 x Transparent Kayak 2-seat',
    '2 x Inflatable SUP Jobe',
    '1 x Inflatable SUP',
    '1 x Aqua Glide Recoil 95\' with Slide & Bag',
    '1 x Aqua Glide HD Runway 10\'',
    '1 x Jobe Water Carpet',
    '3 x Jobe Crusher Towable (1 pair)',
    '2 x Jobe Sonar Towable (1 pair)',
    '2 x Jobe Chaser Towable (2 pair)',
    '1 x Funair Jet-Joust',
    '1 x Rescue Float',
    '1 x Waterpolo goal adult',
    '1 x Waterpolo goal teenager',
    '1 x Waterpolo goal junior',
    '1 x Hooverball',
    '1 x Waterbasket',
    '1 x Waterball',
    '1 x Watervolley',
    '1 x Paddleboard',
    '2 x Fliteboard, electronic',
    '2 x E - Bicycles Futura',
    '2 x Trekking Bicycles'
  ];

  const highlights = [
    'Stunning modern design with exceptional interior volume',
    'Expansive beach club with fold-down platforms',
    'Large swimming pool on the main deck aft',
    'Fully equipped gym with state-of-the-art equipment',
    'Luxurious spa facilities with massage room and Hammam',
    'Helipad for convenient guest transfers',
    'Elevator serving all decks',
    'Extensive collection of water toys and tenders',
    'Jacuzzi on the sundeck with panoramic views',
    'Al fresco dining areas on multiple decks',
    'Professional crew of 31 ensuring impeccable service',
    'Zero-speed stabilizers for ultimate comfort'
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Image Gallery */}
      <div className="pt-20">
        <div className="relative h-[70vh]">
          <img
            src={images[selectedImage]}
            alt="O'PARI Superyacht"
            className="w-full h-full object-cover"
          />
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => setSelectedImage(index)}
                className={`w-2 h-2 rounded-full transition-all ${
                  selectedImage === index ? 'bg-white w-8' : 'bg-white/60'
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Quick Specs Bar */}
      <div className="bg-gray-50 border-y border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex flex-wrap items-center justify-between gap-4 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-ship-line text-teal-600"></i>
              <span className="font-medium">311' 8" (95m) Golden Yachts</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-calendar-line text-teal-600"></i>
              <span>Built 2020/2021</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-group-line text-teal-600"></i>
              <span>12 Guests · 7 Cabins</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-user-star-line text-teal-600"></i>
              <span>31 Crew</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-price-tag-3-line text-teal-600"></i>
              <span className="font-semibold">From €1,150,000/week</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Left Column - Main Content */}
          <div className="lg:col-span-2 space-y-12">
            {/* Header */}
            <div>
              <h1 className="text-5xl font-bold text-gray-900 mb-4">O'PARI</h1>
              <p className="text-xl text-gray-600">311' 8" Golden Yachts · 2020/2021</p>
            </div>

            {/* Overview */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Overview</h2>
              <div className="prose prose-lg max-w-none text-gray-700 space-y-4">
                <p>
                  The 2020 launched O'PARI is an extraordinary mega yacht ideal for both large charter parties and entertaining. Custom built by the Greek shipyard Golden Yachts, she is a stunning example of contemporary design and exudes that all-encompassing feeling of extraordinary design and sublime level of innovative and entertaining features.
                </p>
                <p>
                  Designed by Studio Vafiadis, O'PARI is a masterclass in the use of space. Her six decks (including the sun deck) are a testament to the highest standards of mega yacht design.
                </p>
                <p>
                  Created by Studio Vafiadis, O'PARI is loaded with both dazzling and sophisticated features. She is a masterclass in the use of space throughout her six decks. She is blessed with an expansive beach club, a large swimming pool on the main deck aft, a fully equipped gym, a luxurious spa with massage room and Hammam, and a helipad. She is blessed with the sense of space throughout her guest areas. Her main salon is the heart of the yacht. Open-plan and set on the incredible 15m beam, she is blessed with an abundance of natural light and boasts the sense of space throughout. She is equipped with a bar and lounge area where guests can relax and enjoy the stunning views.
                </p>
              </div>
            </div>

            {/* Specifications */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Specifications</h2>
              <div className="grid grid-cols-2 gap-4">
                {specifications.map((spec, index) => (
                  <div key={index} className="flex justify-between py-3 border-b border-gray-200">
                    <span className="text-gray-600">{spec.label}</span>
                    <span className="font-medium text-gray-900">{spec.value}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Amenities */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Amenities</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {amenities.map((amenity, index) => (
                  <div key={index} className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-teal-50 rounded-full flex items-center justify-center mb-3">
                      <i className={`${amenity.icon} text-2xl text-teal-600`}></i>
                    </div>
                    <span className="text-sm text-gray-700">{amenity.label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Accommodation */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Accommodation</h2>
              <div className="prose prose-lg max-w-none text-gray-700">
                <p>
                  O'PARI accommodates 12 guests in 7 beautifully appointed cabins, all featuring ensuite facilities and the finest amenities. The master suite is a sanctuary of luxury, offering panoramic views, a private study, and an opulent bathroom. Six additional guest cabins provide exceptional comfort and style, ensuring every guest enjoys a memorable stay.
                </p>
                <p>
                  The yacht is serviced by a professional crew of 31, dedicated to providing impeccable service throughout your charter.
                </p>
              </div>
            </div>

            {/* Highlights */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Highlights</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {highlights.map((highlight, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700">{highlight}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Toys & Tenders */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Toys & Tenders</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {toysAndTenders.map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-lg mt-0.5 flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Charter Destinations */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Charter Destinations</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Summer Season</h3>
                  <p className="text-gray-700 mb-4">Mediterranean, West Mediterranean, Monaco, French Riviera, Corsica, Sardinia, Balearics, Italian Riviera, Croatia, East Mediterranean, Greece, Cyclades, Turkey</p>
                  <div className="text-2xl font-bold text-teal-600">€1,150,000/week</div>
                  <p className="text-sm text-gray-600 mt-1">Plus expenses</p>
                </div>
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Winter Season</h3>
                  <p className="text-gray-700 mb-4">Mediterranean, West Mediterranean, Monaco, French Riviera, Corsica, Sardinia, Balearics, Italian Riviera, Croatia, East Mediterranean, Greece, Cyclades, Turkey</p>
                  <div className="text-2xl font-bold text-orange-600">€1,150,000/week</div>
                  <p className="text-sm text-gray-600 mt-1">Plus expenses</p>
                </div>
              </div>
            </div>

            {/* Crew */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Professional Crew</h2>
              <div className="prose prose-lg max-w-none text-gray-700">
                <p>
                  O'PARI is operated by a highly experienced and professional crew of 31, dedicated to ensuring every aspect of your charter exceeds expectations. From the captain and officers to the chef, stewardesses, and deck crew, each team member is committed to providing exceptional service, attention to detail, and creating unforgettable experiences for all guests aboard.
                </p>
              </div>
            </div>
          </div>

          {/* Right Column - Sidebar */}
          <div className="lg:col-span-1">
            <div className="sticky top-24 space-y-6">
              {/* Charter Rates Card */}
              <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 text-white shadow-xl">
                <h3 className="text-2xl font-bold mb-6">Charter Rates</h3>
                <div className="space-y-6">
                  <div>
                    <div className="text-sm opacity-90 mb-1">Summer 2025</div>
                    <div className="text-3xl font-bold">€1,150,000</div>
                    <div className="text-sm opacity-75">per week + expenses</div>
                  </div>
                  <div className="border-t border-white/20 pt-6">
                    <div className="text-sm opacity-90 mb-1">Winter 2025/2026</div>
                    <div className="text-3xl font-bold">€1,150,000</div>
                    <div className="text-sm opacity-75">per week + expenses</div>
                  </div>
                </div>
                <div className="mt-8 pt-6 border-t border-white/20">
                  <div className="flex items-center gap-2 text-sm mb-2">
                    <i className="ri-group-line"></i>
                    <span>Up to 12 guests</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm mb-2">
                    <i className="ri-home-smile-line"></i>
                    <span>7 luxurious cabins</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm">
                    <i className="ri-user-star-line"></i>
                    <span>Professional crew of 31</span>
                  </div>
                </div>
              </div>

              {/* Inquiry Form */}
              <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Charter Inquiry</h3>
                <CharterInquiryForm yachtName="O'PARI" />
              </div>

              {/* Quick Contact */}
              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-200">
                <h4 className="font-bold text-gray-900 mb-4">Need Assistance?</h4>
                <p className="text-sm text-gray-600 mb-4">
                  Our charter specialists are available to answer your questions and help plan your perfect yacht charter experience.
                </p>
                <a
                  href="mailto:info@superyachtglobal.com"
                  className="flex items-center justify-center gap-2 w-full bg-teal-600 text-white px-6 py-3 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap"
                >
                  <i className="ri-mail-line"></i>
                  <span>Contact Us</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default OPariPage;